<template>
  <div class="base-header">
    <div class="left-box">
      <img height="40" src="@/assets/imgs/logo.png" alt="" @click="goHome" />
      <span class="title" @click="goHome">智慧应急管理与决策实验室</span>
    </div>
    <div class="right-box">
      <span class="menu" @click="goHelp">帮助中心</span>
      <span class="phone-menu" @click="goHelp">帮助</span>
      <el-dropdown v-if="isLogin">
        <span class="el-dropdown-link">
          <span class="name">
            {{ userInfo.name ? userInfo.name : "用户" }}
          </span>
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="logOut">退出</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <div class="not-logged-in" v-else>
        <el-button
          class="login-button"
          @click="handleClickGoLogin"
          type="primary"
        >
          登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  onMounted,
  inject,
} from "vue";
import { checkUserLoginStatus } from "@/utils/utils.js";
import VueCookies from "vue-cookies";
import { goLogin } from "@/utils/login";
import { httpAuthPost } from "@/api/httpService";
import { ElMessage, ElNotification } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";

const openDialogLogin = inject("openDialogLogin");

const router = useRouter();
const route = useRoute();

//是否登录
const userInfo = ref({});
const isLogin = ref(false);
onMounted(async () => {
  if (checkUserLoginStatus()) {
    userInfo.value = VueCookies.get("userInfo");
    isLogin.value = true;
  } else {
    isLogin.value = false;
  }
});

//登录
const handleClickGoLogin = () => {
  openDialogLogin();
};

//退出
const logOut = async () => {
  let res = await httpAuthPost("/centerAuth/v1/exit");
  if (res.code == 0) {
    let { userId } = VueCookies.get("userInfo");
    store.commit("setLoginStatus", {
      status: false,
    });
    VueCookies.remove("tokenWeb");
    VueCookies.remove("userInfo");
    VueCookies.remove("tokenWebRefresh");
    VueCookies.remove("tokenWeb", "/", "smartsowo.com");
    VueCookies.remove("userInfo", "/", "smartsowo.com");
    VueCookies.remove("tokenWebRefresh", "/", "smartsowo.com");
    window.sessionStorage.setItem("ifLoginPROGRAM_" + userId, false);
    ElMessage.success("退出成功");
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};

//帮助中心
const goHelp = () => {
  window.open("https://help.ringdata.com/", "_blank");
};
const goHome = () => {
  router.push({
    name: "Home",
    query: {
      type: route.query.type,
    },
  });
};
</script>

<style lang="scss" scoped>
.base-header {
  height: $header-height;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0px 2px 15px -10px rgba(132, 132, 134, 0.4);
  position: relative;
  z-index: 1;
  padding: 0 30px;
  .left-box {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 16px;
    font-weight: 550;
    img {
      cursor: pointer;
    }
    .title {
      color: #fff;
      cursor: pointer;
    }
  }
  .right-box {
    display: flex;
    gap: 40px;
    align-items: center;
    .phone-menu {
      display: none;
    }
    .menu {
      color: #fff;
      font-weight: 550;
      cursor: pointer;
      position: relative;
      top: 2px;
    }
    .menu:hover {
      color: $theme-color;
    }
    .name {
      color: #fff;
      font-weight: 550;
    }
    .el-icon--right {
      color: #fff;
    }
  }
}
@media only screen and (max-width: 767px) {
  .base-header {
    padding: 0 15px;
    .left-box {
      img {
        height: 25px;
      }
      .title {
        display: none;
        font-size: 14px;
      }
    }
    .right-box {
      gap: 20px;
      .phone-menu {
        display: block;
        color: #fff;
        font-size: 14px;
        font-weight: 550;
        position: relative;
        top: 1px;
      }
      .menu {
        display: none;
      }
      .name {
        color: #fff;
      }
    }
  }
}
</style>
